import React from "react";

// reactstrap components
import {
    Alert,
    Card,
    Button,
    CardHeader,
    CardBody,
    Table,
    Modal,
} from "reactstrap";
import NumberFormat from 'react-number-format';
import DeductDataService from "../../services/DeductDataService";

class CheckoutHistoryModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            defaultModal: false,
            currentCheckout: {},
            currentCheckoutListItem: {},
        };
        this.DeductDataService = new DeductDataService();
    }

    onModalOpened() {
        this.setCurrentCheckout();
    }

    onModalClosed() {
        this.setState({
            currentProduct: {},
            errorMessages: [],
        })
    }

    setCurrentCheckout() {
        this.DeductDataService.get(this.props.currentCheckout.order_id)
            .then((res) => {
                this.setState({
                    currentCheckout: res.checkout,
                    currentCheckoutListItem: this.props.currentCheckout,
                })
            })
    }

    handleDeleteTrx(transaction_id) {
        this.DeductDataService.disable(transaction_id)
            .then((data) => {
                this.handleResponse(data, "Transaksi berhasil dinonaktifkan");
            });
    }

    handleResponse(data, successMessage) {
        if (data.data?.errorMessage !== undefined) {
            this.props.setErrorMessage(data.data.errorMessage);
        } else if (data.header?.status_code !== 200) {
            let errorMessages = []
            data?.data?.map((data) => {
              return errorMessages.push(data?.error_message)
            })
            this.setState({ errorMessages: errorMessages })
        } else {
            this.props.toggleModal();
            this.props.setSuccessMessage(successMessage);
            this.props.fetchData();
        }
    }

    setSuccessMessage = (message) => {
        this.setState({ successMessage: message})
        setTimeout(() => {
          this.setState({ successMessage: undefined })
        }, 5000);
    }

    setErrorMessage = (message) => {
        this.setState({ errorMessage: message})
        setTimeout(() => {
          this.setState({ errorMessage: undefined })
        }, 5000);
    }

    render() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.props.formModal}
                toggle={this.props.toggleModal}
                onOpened={this.onModalOpened.bind(this)}
                onClosed={this.onModalClosed.bind(this)}
            >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent">
                            <div className="text-muted text-center mt-2 mb-3">
                                <h3 className="mb-0">Detil checkout</h3>
                            </div>
                        </CardHeader>
                        <CardBody className="px-lg-5 py-lg-5">
                            {this.state.successMessage && (
                                <Alert color="info">
                                    {this.state.successMessage}
                                </Alert>
                            )}
                            {this.state.errorMessages && this.state.errorMessages.map((errorMessage) => (
                                <Alert color="danger">
                                    {errorMessage}
                                </Alert>
                            ))}
                            <h3>Daftar barang checkout</h3>
                            <Table className="align-items-center table-flush" responsive>
                                <tbody>
                                    {this.state.currentCheckout?.transaction && this.state.currentCheckout.transaction.map((transaction) => (
                                        <tr>
                                            <th>
                                                {transaction.product_name}
                                            </th>
                                            <td>
                                                {transaction.qty}
                                            </td>
                                            <td>
                                                {(transaction.discounted_price !== null) && (
                                                    <span>
                                                        <del>
                                                            <NumberFormat
                                                                value={transaction.sell_price}
                                                                displayType={'text'}
                                                                thousandSeparator={true}
                                                                prefix={'Rp.'} suffix={',00'} />
                                                        </del><br />
                                                        <NumberFormat
                                                            value={transaction.discounted_price}
                                                            displayType={'text'}
                                                            thousandSeparator={true}
                                                            prefix={'Rp.'} suffix={',00'} />
                                                    </span>
                                                )}
                                                {(transaction.discounted_price == null) && (
                                                    <NumberFormat
                                                        value={transaction.sell_price}
                                                        displayType={'text'}
                                                        thousandSeparator={true}
                                                        prefix={'Rp.'} suffix={',00'} />
                                                )}
                                            </td>
                                            <td>
                                            <Button
                                                color="danger"
                                                type="button"
                                                onClick={() => this.handleDeleteTrx(transaction.transaction_id)}
                                                size="sm">
                                                Hapus</Button>
                                            </td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <th>
                                            Subtotal
                                    </th>
                                        <td></td>
                                        <td>
                                            <b><NumberFormat
                                                value={this.state.currentCheckout.total_profit}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                                prefix={'Rp.'} suffix={',00'} />
                                            </b>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                            <h3 className="mt-3">Detil checkout</h3>
                            <Table className="align-items-center table-flush" responsive>
                                <tbody>
                                    <tr>
                                        <th>Checkout ID</th>
                                        <td>{this.state.currentCheckoutListItem.order_id}</td>
                                    </tr>
                                    <tr>
                                        <th>Metode Pembayaran</th>
                                        <td>{this.state.currentCheckoutListItem.nik > 0 ? 'Cashbon' : 'Cash'}</td>
                                    </tr>
                                    <tr>
                                        <th>NIK Pembeli</th>
                                        <td>{this.state.currentCheckoutListItem.nik > 0 ? this.state.currentCheckoutListItem.nik : '-'}</td>
                                    </tr>
                                    <tr>
                                        <th>Tanggal checkout</th>
                                        <td>
                                            {new Date(this.state.currentCheckoutListItem.created_at).toLocaleDateString()
                                                + ' ' + new Date(this.state.currentCheckoutListItem.created_at).toLocaleTimeString()}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }
}

export default CheckoutHistoryModal;